import React from 'react';
import { Message as MessageType } from '../../types/kyb';

interface MessageProps {
  message: MessageType;
  onSuggestionClick?: (suggestion: string) => void;
}

const Message: React.FC<MessageProps> = ({ message, onSuggestionClick }) => {
  const isAI = message.sender === 'ai';

  return (
    <div className={`mb-5 ${isAI ? '' : 'flex justify-end'}`}>
      <div
        className={`${
          isAI
            ? 'bg-primary-50 border border-primary-100 text-neutral-800 rounded-2xl rounded-tl-none shadow-sm'
            : 'bg-white border border-neutral-200 rounded-2xl rounded-tr-none shadow-sm'
        } px-5 py-4 max-w-md transition-all hover:shadow-card`}
      >
        {/* Message header */}
        <div className="flex items-start mb-2">
          {isAI && (
            <div className="w-9 h-9 rounded-xl bg-gradient-to-r from-primary-400 to-primary-600 flex items-center justify-center text-white mr-3 flex-shrink-0 shadow-sm">
              <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
              </svg>
            </div>
          )}
          <div>
            <div className={`text-sm font-semibold ${isAI ? 'text-primary-700' : 'text-neutral-800 text-right'}`}>
              {isAI ? 'BYNN Assistant' : 'You'}
            </div>
            <div className="text-xs text-neutral-500 mt-0.5">{message.timestamp}</div>
          </div>
        </div>

        {/* Message content */}
        <div className={`text-sm leading-relaxed ${isAI ? 'text-neutral-800' : 'text-neutral-700'}`}>
          {message.message}
        </div>

        {/* Suggestion chips */}
        {isAI && message.suggestions && message.suggestions.length > 0 && (
          <div className="flex flex-wrap mt-4 gap-2">
            {message.suggestions.map((suggestion, index) => (
              <button
                key={index}
                onClick={() => onSuggestionClick && onSuggestionClick(suggestion)}
                className="bg-white text-primary-600 border border-primary-200 hover:border-primary-300 hover:bg-primary-50 
                          transition-all rounded-full px-3.5 py-1.5 text-sm font-medium shadow-button"
              >
                {suggestion}
              </button>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default Message;